import { SummaryPage } from "@appretio/cube";
import { RESTORES_FEEDBACK_VIEW_HANDLE } from "@appretio/feedback";
import { LazyRoute } from "@appretio/shared";
import { ErrorBoundary, semanticThemeTokens } from "@appretio/ui-kit";
import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";

const ForecastPage = lazy(() =>
  import("./forecastPage/ForecastPage").then((m) => ({
    default: m.ForecastPage
  }))
);

const InSeasonReviewPage = lazy(() =>
  import("./inSeasonReviewPage/InSeasonReviewPage").then((m) => ({
    default: m.InSeasonReviewPage
  }))
);

const ManageCubesPage = lazy(() =>
  import("./manageCubesPage/ManageCubesPage").then((m) => ({
    default: m.ManageCubesPage
  }))
);

const OtbPage = lazy(() =>
  import("./otbPage/OtbPage").then((m) => ({
    default: m.OtbPage
  }))
);

const ROOT = "in-season" as const;

const PATH = {
  FORECAST: "in-season-forecast/forecast",
  MANAGE_CUBES: "in-season-forecast/manage-cubes",
  OTB: "in-season-forecast/otb",
  FORECAST_SUMMARY: "in-season-forecast/summary",
  IN_SEASON_REVIEW: "in-season-review"
} as const;

const LABEL = {
  ROOT: "In-season",
  FORECAST: "Forecast",
  MANAGE_CUBES: "Manage Cubes",
  OTB: "Open To Buy",
  FORECAST_SUMMARY: "Summary",
  IN_SEASON_REVIEW: "In-season Review"
} as const;

const inSeasonRouteHandles = {
  [PATH.FORECAST]: {
    label: LABEL.FORECAST
  },
  [PATH.MANAGE_CUBES]: {
    label: LABEL.MANAGE_CUBES
  },
  [PATH.OTB]: {
    label: LABEL.OTB
  },
  [PATH.FORECAST_SUMMARY]: {
    label: LABEL.FORECAST_SUMMARY,
    ...RESTORES_FEEDBACK_VIEW_HANDLE
  },
  [PATH.IN_SEASON_REVIEW]: {
    label: LABEL.IN_SEASON_REVIEW
  }
} as const;

export const inSeasonRoutes: RouteObject = {
  path: ROOT,
  handle: {
    label: LABEL.ROOT,
    background: semanticThemeTokens.backgroundGradient[2]
  },
  element: <Outlet />,
  children: [
    {
      path: PATH.FORECAST,
      handle: inSeasonRouteHandles[PATH.FORECAST],
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <ForecastPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      path: PATH.MANAGE_CUBES,
      handle: inSeasonRouteHandles[PATH.MANAGE_CUBES],
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <ManageCubesPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      path: PATH.OTB,
      handle: inSeasonRouteHandles[PATH.OTB],
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <OtbPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      path: PATH.FORECAST_SUMMARY,
      handle: inSeasonRouteHandles[PATH.FORECAST_SUMMARY],
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <SummaryPage saveProducer="user" />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      path: PATH.IN_SEASON_REVIEW,
      handle: inSeasonRouteHandles[PATH.IN_SEASON_REVIEW],
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <InSeasonReviewPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    }
  ]
};
